import request from 'superagent';

const API_BASE = process.env.REACT_APP_GENELINK_API_BASE;

/**
 * PUT /api/media/impression を fire-and-forget で送信する
 * @param {{ creative_id: string, placement: string, code: string }} params
 */
export function sendImpression({ creative_id, placement, code }) {
  if (!API_BASE) {
    return;
  }

  request
    .put(`${API_BASE}/api/media/impression`)
    .send({ creative_id, placement, code })
    .end((err) => {
      if (err) {
        console.error('[geneLinkService] sendImpression failed:', err);
      }
    });
}

/**
 * PUT /api/media/view を fire-and-forget で送信する
 * @param {{ creative_id: string, placement: string, code: string, sub?: string|number }} params
 */
export function sendView({ creative_id, placement, code, sub }) {
  if (!API_BASE) {
    return;
  }

  const payload = { creative_id, placement, code };
  if (sub != null) {
    payload.sub = sub;
  }

  request
    .put(`${API_BASE}/api/media/view`)
    .send(payload)
    .end((err) => {
      if (err) {
        console.error('[geneLinkService] sendView failed:', err);
      }
    });
}

/**
 * adscreen ページの URL を構築して返す
 * @param {{ creative_id: string, code: string }} params
 * @returns {string}
 */
export function buildAdscreenUrl({ creative_id, code, customer_id }) {
  let url = `${API_BASE}/adscreen?creative_id=${creative_id}&code=${code}`;
  if (customer_id != null) {
    url += `&customer_id=${customer_id}`;
  }
  return url;
}



// WEBPACK FOOTER //
// ./src/services/geneLinkService.js